module.exports = __webpack_public_path__ + "static/media/Tavrika.dc3be04e.jpg";